module.exports = {"520112004":"观溪路街道","520112005":"新光路街道","520112006":"新创路街道","520112007":"龙广路街道","520112008":"高新路街道","520112101":"东风镇","520112102":"水田镇","520112103":"羊昌镇","520112105":"下坝镇","520112106":"新场镇","520112107":"百宜镇","520112203":"新堡布依族乡","520112206":"偏坡布依族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520112.json
// module id = 2582
// module chunks = 0